import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  const user = authService.currentUser();

  if (user && user.is_change_password === 0) {
    return router.createUrlTree(['/set-password']);
  }

  return true;
};

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  const user = authService.currentUser();

  if (user && user.is_change_password === 0) {
    return router.createUrlTree(['/set-password']);
  }

  if (!authService.isAdmin()) {
    return router.createUrlTree(['/']);
  }

  return true;
};

export const loginPageGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return true;
  }

  const user = authService.currentUser();

  if (user && user.is_change_password === 0) {
    return router.createUrlTree(['/set-password']);
  }

  return router.createUrlTree(['/']);
};

export const setPasswordPageGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  const user = authService.currentUser();

  if (user && user.is_change_password === 0) {
    return true;
  }

  return router.createUrlTree(['/']);
};

export const permissionGuard = (
  requiredPermission: string
): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isLoggedIn()) {
      return router.createUrlTree(['/login']);
    }

    const user = authService.currentUser();

    if (user && user.is_change_password === 0) {
      return router.createUrlTree(['/set-password']);
    }

    if (authService.hasPermission(requiredPermission)) {
      return true;
    }

    return router.createUrlTree(['/']);
  };
};

export const seoGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  const user = authService.currentUser();

  if (user && user.is_change_password === 0) {
    return router.createUrlTree(['/set-password']);
  }

  if (user?.role?.name === 'seo') {
    return true;
  }

  return router.createUrlTree(['/']);
};

export const nonSeoGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  const user = authService.currentUser();

  if (user && user.is_change_password === 0) {
    return router.createUrlTree(['/set-password']);
  }

  if (user?.role?.name === 'seo') {
    return router.createUrlTree(['/seo']);
  }

  return true;
};

export const cartManagerGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  const user = authService.currentUser();

  if (user && user.is_change_password === 0) {
    return router.createUrlTree(['/set-password']);
  }

  if (user?.role?.name === 'CartManager' || user?.role?.name === 'Admin') {
    return true;
  }

  return router.createUrlTree(['/']);
};
